import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentsSection, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { LoadingBox } from "component/basic/popup";
import { FixedPage } from "component/basic";
import { NotItems } from "component/basic/notItems";
import { PointFixedTap, Tap } from "component/basic/tap";
import { FixedContents } from "component/product/page";
import { BoardListBox, BoardListItem, CsControll } from "component/board/items";

const Event = (props) => {
    const navigate = useNavigate();

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const [category,setCategory] =  useState(null);

    const pageDataApi = useGet({
        url:`/event${category ? `?status=${category}` : ""}`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data?.events;

    useEffect(() => {
        setLoadingBoxOpen(false);
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg mTapContents"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"이벤트"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={2}
                    closeFunc={()=>{}}
                />
                <FixedPage addClass="reverse mnReverse">
                    <CsControll boxAddClass="pcItemT"/>
                    <FixedContents>
                        <PageTitle
                            addClass="fixedContents_title pcItemT"
                            pageBack={null}
                            contents="이벤트"
                        >
                            <Tap
                                addClass="underLine pcItemT"
                                data={[
                                    {
                                        id:1,
                                        name:"진행중"
                                    },
                                    {
                                        id:2,
                                        name:"마감됨"
                                    }
                                ]}
                                nameKey={"name"}
                                valKey={"id"}
                                nameCaption={null}
                                val={category}
                                allText="전체"
                                func={(name,val)=>{setCategory(val)}}
                            />
                        </PageTitle>
                        <PointFixedTap
                            boxAddClass={"mItemT row"}
                            headerTap={true}
                            headerChk={true}
                            addClass=""
                            data={[
                                {
                                    id:1,
                                    name:"진행중"
                                },
                                {
                                    id:2,
                                    name:"마감됨"
                                }
                            ]}
                            nameKey={"name"}
                            valKey={"id"}
                            nameCaption={null}
                            val={category}
                            allText="전체"
                            func={(name,val)=>{setCategory(val)}}
                        />
                        <BoardListBox>
                            {pageData && pageData?.length > 0 ? 
                                <>
                                    {pageData && pageData?.map((item, i) => (
                                        <BoardListItem
                                            key={i}
                                            type="event"
                                            data={item}
                                        />
                                    ))}
                                </>
                            :
                                <NotItems addClass="fullPage" text={`이벤트 내역이 없습니다.`}/>
                            }
                        </BoardListBox>
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <Footer/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default Event;